const Inicio = () => {
    return (
        <main className="main">

            {/* Inicio */}
            <section id="hero" className="hero section">

                <div className="hero-background">
                    <img src="/assets/images/bg/bg.png" alt="" data-aos="zoom-out" data-aos-duration="1000" />
                    <div className="overlay"></div>
                </div>

                <div className="container" data-aos="fade-up" data-aos-delay="200">
                    <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="hero-content">
                        <h1 data-aos="fade-right" data-aos-delay="400">Consultoría bancaria estratégica para PyMEs</h1>
                        <p data-aos="fade-right" data-aos-delay="500">La mayoría de las PyMEs paga tasas, comisiones y seguros que nunca debió aceptar. Nosotros te decimos exactamente qué sí y qué no.</p>
                        <div className="hero-actions" data-aos="fade-right" data-aos-delay="600">
                            <a href="#contact" className="btn-primary">Solicita una asesoría gratis</a>
                        </div>
                        <div className="hero-stats" data-aos="fade-up" data-aos-delay="700">
                            <div className="stat-item">
                            <span className="stat-number">100+</span>
                            <span className="stat-label">Asesorías a PyMEs reales</span>
                            </div>
                            <div className="stat-item">
                            <span className="stat-number">Ahorros</span>
                            <span className="stat-label">Documentados en créditos, comisiones y seguros</span>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="hero-visual" data-aos="fade-left" data-aos-delay="400">
                        <div className="row g-3">
                            <div className="col-6">
                            <div className="feature-card" data-aos="fade-up" data-aos-delay="500">
                                <i className="bi bi-shield-fill-check"></i>
                                <span>Conocimiento profundo</span>
                            </div>
                            <div className="feature-card" data-aos="fade-up" data-aos-delay="700">
                                <i className="bi bi-people-fill"></i>
                                <span>Acompañamiento humano</span>
                            </div>
                            </div>
                            <div className="col-6">
                            <div className="feature-card" data-aos="fade-up" data-aos-delay="600">
                                <i className="bi bi-cpu-fill"></i>
                                <span>Integración con IA</span>
                            </div>
                            <div className="feature-card" data-aos="fade-up" data-aos-delay="800">
                                <i className="bi bi-trophy-fill"></i>
                                <span>Resultados tangibles</span>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>

            </section>

            {/* Nosotros */}
            <section id="about" className="about section light-background">

                {/* Section Title */}
                <div className="container section-title" data-aos="fade-up">
                    <h2>Nosotros</h2>
                </div>

                <div className="container" data-aos="fade-up" data-aos-delay="100">

                    <div className="row align-items-center mb-5">
                        <div className="col-lg-5 mb-4 mb-lg-0" data-aos="zoom-in" data-aos-delay="200">
                            <img src="/assets/images/about/about.jpeg" className="img-fluid rounded shadow" alt="Comprehensive solutions for business success" />
                        </div>
                        <div className="col-lg-7" data-aos="fade-left" data-aos-delay="300">
                            <div className="about-content">
                                <h2 className="mb-3">Nuestra historia y propósito</h2>
                                <p className="lead mb-3">
                                    La mayoría de las PyMEs mexicanas firman condiciones bancarias que no terminan de entender — no por falta de capacidad, sino porque el banco no tiene ningún incentivo para explicarlas con claridad. GOODLIC existe para cerrar esa brecha: inteligencia bancaria hecha por gente que sabe cómo se negocian de verdad las condiciones, puesta del lado de la empresa.
                                </p>
                                <p>
                                    Nuestro nombre lo resume: GOOD — Leadership In Consulting.
                                    <br />
                                    <br />
                                    Acompañamos a pequeñas y medianas empresas con asesoría clara, imparcial y estratégica — para que entiendan y optimicen cada producto bancario que usan, con resultados documentados y confirmados.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row g-4">
                        <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
                            <article className="about-card h-100">
                                <div className="icon-wrap mb-3">
                                    <i className="bi bi-person-gear"></i>
                                </div>
                                <h5 className="mb-2">Estrategia personalizada</h5>
                                <p>Analizamos tus necesidades reales y trazamos un camino financiero claro.</p>
                            </article>
                        </div>
                        <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
                            <article className="about-card h-100">
                                <div className="icon-wrap mb-3">
                                    <i className="bi bi-bank"></i>
                                </div>
                                <h5 className="mb-2">Imparcialidad total</h5>
                                <p>No representamos a bancos, representamos tus intereses.</p>
                            </article>
                        </div>
                        <div className="col-md-4" data-aos="fade-up" data-aos-delay="300">
                            <article className="about-card h-100">
                                <div className="icon-wrap mb-3">
                                    <i className="bi bi-file-bar-graph-fill"></i>
                                </div>
                                <h5 className="mb-2">Resultados medibles</h5>
                                <p>Nuestro enfoque está orientado a reducir tus costos y optimizar tus créditos.</p>
                            </article>
                        </div>
                    </div>

                </div>

            </section>

            {/* Servicios */}
            <section id="services" className="services section">

                {/* Section Title */}
                <div className="container section-title" data-aos="fade-up">
                    <h2>Servicios</h2>
                </div>

                <div className="container" data-aos="fade-up" data-aos-delay="100">

                    <div class="tabs-wrapper mb-5">
                        <div class="tabs-header" data-aos="fade-up" data-aos-delay="200">
                            <ul class="nav nav-tabs">
                                <li class="nav-item">
                                    <a class="nav-link active show" data-bs-toggle="tab" data-bs-target="#tabs-tab-1">
                                    <div class="tab-content-preview">
                                        <span class="tab-number">01</span>
                                        <div class="tab-text">
                                        <h6>Detectamos</h6>
                                        <small>problemas financieros</small>
                                        </div>
                                    </div>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" data-bs-toggle="tab" data-bs-target="#tabs-tab-2">
                                    <div class="tab-content-preview">
                                        <span class="tab-number">02</span>
                                        <div class="tab-text">
                                        <h6>Corregimos</h6>
                                        <small>condiciones bancarias</small>
                                        </div>
                                    </div>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" data-bs-toggle="tab" data-bs-target="#tabs-tab-3">
                                    <div class="tab-content-preview">
                                        <span class="tab-number">03</span>
                                        <div class="tab-text">
                                        <h6>Optimizamos</h6>
                                        <small>y preparamos el crecimiento</small>
                                        </div>
                                    </div>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div class="tab-content" data-aos="fade-up" data-aos-delay="300">

                            <div class="tab-pane fade active show" id="tabs-tab-1">
                                <div class="row align-items-center">
                                    {/* Card 1 */}
                                    <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="100">
                                        <div className="service-item">
                                            <div className="icon">
                                                <i className="bi bi-clipboard-pulse"></i>
                                            </div>
                                            <h3>Diagnóstico financiero gratuito</h3>
                                            <p>Evaluamos sin costo la salud financiera de tu empresa para detectar oportunidades de mejora, riesgos ocultos y puntos clave que podrían optimizarse en tu relación con la banca.</p>
                                        </div>
                                    </div>

                                    {/* Card 2 */}
                                    <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="200">
                                        <div className="service-item">
                                            <div className="icon">
                                                <i className="bi bi-graph-up"></i>
                                            </div>
                                            <h3>Análisis de condiciones bancarias actuales</h3>
                                            <p>Revisamos tus créditos, tasas, comisiones y líneas bancarias para identificar si estás obteniendo las mejores condiciones disponibles en el mercado financiero.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="tabs-tab-2">
                                <div class="row align-items-center">
                                    {/* Card 3 */}
                                    <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="300">
                                        <div className="service-item">
                                            <div className="icon">
                                                <i className="bi bi-arrow-repeat"></i>
                                            </div>
                                            <h3>Reestructuración de deudas</h3>
                                            <p>Te ayudamos a reorganizar tus compromisos financieros con instituciones bancarias para reducir pagos mensuales, ampliar plazos o mejorar tasas de interés, mejorando tu flujo de efectivo.</p>
                                        </div>
                                    </div>

                                    {/* Card 4 */}
                                    <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="100">
                                        <div className="service-item">
                                            <div className="icon">
                                                <i className="bi bi-people"></i>
                                            </div>
                                            <h3>Acompañamiento en negociación con bancos</h3>
                                            <p>Negociamos contigo y por ti frente a las instituciones financieras, utilizando nuestro conocimiento experto del sistema bancario para obtener condiciones más justas y convenientes.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="tabs-tab-3">
                                <div class="row align-items-center">
                                    {/* Card 5 */}
                                    <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="200">
                                        <div className="service-item">
                                            <div className="icon">
                                                <i className="bi bi-bank"></i>
                                            </div>
                                            <h3>Asesoría para nuevos créditos</h3>
                                            <p>Te guiamos en todo el proceso de contratación de nuevos financiamientos, desde el análisis de necesidad hasta la elección del banco, asegurando condiciones óptimas y alineadas a tu estrategia.</p>
                                        </div>
                                    </div>

                                    {/* Card 6 */}
                                    <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="300">
                                        <div className="service-item">
                                            <div className="icon">
                                                <i className="bi bi-cash-stack"></i>
                                            </div>
                                            <h3>Optimización de comisiones</h3>
                                            <p>Detectamos y reducimos comisiones bancarias innecesarias mediante un análisis detallado de tus estados de cuenta, generando ahorros reales y sostenibles para tu empresa.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="services-header mt-5" data-aos="fade-up" data-aos-delay="200">
                        <div className="row align-items-center">
                            <div className="col-lg-12">
                                <h3>Beneficios de trabajar con Goodlic</h3>
                            </div>
                        </div>
                    </div>

                    <div className="services-benefits" data-aos="fade-up" data-aos-delay="300">
                        <div class="row">

                            <div class="col-lg-5" data-aos="fade-up" data-aos-delay="200">
                                <div class="content-wrapper">
                                    <div class="section-label">¿Qué obtienes al trabajar con Goodlic?</div>
                                    <h2>Resultados claros, sin venderte productos bancarios</h2>
                                    <p>En Goodlic no te decimos qué banco elegir. Te decimos qué te conviene y por qué.</p>
                                </div>
                            </div>

                            <div class="col-lg-7" data-aos="fade-up" data-aos-delay="300">
                                <div class="cta-box">

                                    <div class="benefits-grid">
                                        <div class="benefit-item">
                                            <div class="benefit-icon">
                                                <i class="bi bi-shield-check"></i>
                                            </div>
                                            <div class="benefit-content">
                                                <h4>Revisión y mejora de tus créditos actuales</h4>
                                                <p>Analizamos tus condiciones vigentes y te decimos si estás pagando de más o si existen mejores alternativas.</p>
                                            </div>
                                        </div>

                                        <div class="benefit-item">
                                            <div class="benefit-icon">
                                                <i class="bi bi-graph-up-arrow"></i>
                                            </div>
                                            <div class="benefit-content">
                                                <h4>Detección de seguros y comisiones innecesarias</h4>
                                                <p>Identificamos cargos que afectan tu flujo y te explicamos cuáles puedes ajustar o eliminar.</p>
                                            </div>
                                        </div>

                                        <div class="benefit-item">
                                            <div class="benefit-icon">
                                                <i class="bi bi-people"></i>
                                            </div>
                                            <div class="benefit-content">
                                                <h4>Acompañamiento experto en procesos bancarios</h4>
                                                <p>Te guiamos paso a paso para que tomes decisiones informadas y hables con el banco con ventaja.</p>
                                            </div>
                                        </div>

                                        <div class="benefit-item">
                                            <div class="benefit-icon">
                                                <i class="bi bi-lightning"></i>
                                            </div>
                                            <div class="benefit-content">
                                                <h4>Estrategia financiera alineada a tu negocio</h4>
                                                <p>Buscamos la opción que más te conviene a ti, no la que más le conviene al banco.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="services-header mt-5" data-aos="fade-up" data-aos-delay="400">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <h3>Casos de éxito</h3>
                            </div>
                            <div className="col-lg-6 d-flex justify-content-lg-end">
                                <div className="services-controls">
                                    <button className="services-control-btn services-prev"><i className="bi bi-chevron-left"></i></button>
                                    <button className="services-control-btn services-next"><i className="bi bi-chevron-right"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="services-slider swiper init-swiper" data-aos="fade-up" data-aos-delay="500">
                        <div className="swiper-wrapper">

                            <div className="swiper-slide">
                                <div className="services-member">
                                    <div className="member-content">
                                        <h3>Grupo Alimentos San Jorge</h3>
                                        <span>De la incertidumbre al ahorro</span>
                                        <p>Renegociaron su crédito con ayuda de GOODLIC, logrando una tasa 3.5% menor. Hoy ahorran más de $850,000 MXN anuales, que reinvierten en su planta.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="swiper-slide">
                                <div className="services-member">
                                    <div className="member-content">
                                        <h3>Constructora Horizonte</h3>
                                        <span>Solución y mejora</span>
                                        <p>Gracias a la reestructuración de su historial crediticio y una defensa efectiva ante bancos, obtuvieron un crédito puente de $5M MXN, iniciaron 3 desarrollos y duplicaron su facturación.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="swiper-slide">
                                <div className="services-member">
                                    <div className="member-content">
                                        <h3>Distribuidora Automotriz Nova </h3>
                                        <span> De gastar en comisiones a invertir en crecimiento</span>
                                        <p>Tras optimizar sus productos bancarios, redujeron un 40% de costos mensuales y ahora usan esos recursos para importar nuevas autopartes y crecer su catálogo.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="swiper-slide">
                                <div className="services-member">
                                    <div className="member-content">
                                        <h3>Tecnologías Atlas</h3>
                                        <span>Seguros que protegen de verdad</span>
                                        <p>GOODLIC negoció nuevas pólizas con mejores coberturas y un 20% menos en primas anuales. Ahora la empresa protege mejor a su equipo y genera mayor confianza interna.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </section>

            {/* Membresias */}
            <section id="pricing" className="pricing section light-background">

                {/* Section Title */}
                <div className="container section-title" data-aos="fade-up">
                    <h2>Membresías</h2>
                    <p>La mayoría de nuestros clientes recupera la inversión de la membresía en ahorros bancarios</p>
                </div>

                {/* Banner Garantía Goodlic */}
                <div className="container mb-4" data-aos="fade-up" data-aos-delay="50">
                    <div style={{
                        background: 'linear-gradient(135deg, #111F62 0%, #2F328A 60%, #0CB394 100%)',
                        borderRadius: '16px',
                        padding: '2rem 2.5rem',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1.5rem',
                        boxShadow: '0 8px 32px rgba(11,179,148,0.18)'
                    }}>
                        <div style={{
                            background: 'rgba(255,255,255,0.15)',
                            borderRadius: '50%',
                            width: '56px',
                            height: '56px',
                            flexShrink: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '1.8rem'
                        }}>
                            🛡️
                        </div>
                        <div>
                            <p style={{ margin: 0, color: '#fff', fontSize: '1.05rem', lineHeight: 1.5 }}>
                                <strong style={{ color: '#21B4E9' }}>Garantía Goodlic:</strong>{' '}
                                si en 12 meses no te ahorramos al menos <strong style={{ color: '#fff' }}>$10,000</strong>, tu siguiente año es gratis.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="container" data-aos="fade-up" data-aos-delay="100">

                    <div className="row gy-4">

                        {/* Explora */}
                        <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="100">
                            <div className="pricing-card">
                                <div className="plan-header">
                                    <h3 className="plan-name">Explora</h3>
                                    <p className="plan-subtitle">Ideal para conocer y resolver dudas básicas.</p>
                                </div>
                                <div className="plan-pricing">
                                    <div className="price-wrapper">
                                        <span className="currency">$</span>
                                        <span className="amount monthly-price">0</span>
                                    </div>
                                    <p className="billing-info monthly-billing">Siempre gratis</p>
                                </div>
                                <div className="plan-features">
                                    <ul className="features-list">
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            <span>Agente de IA 24/7 por WhatsApp</span>
                                        </li>
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            <span>3 consultas mensuales con tu asesor</span>
                                        </li>
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            <span>Diagnóstico inicial básico</span>
                                        </li>
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            <span>Sin compromiso</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="plan-action">
                                    <a href="/register" className="btn-plan">Crea tu cuenta</a>
                                </div>
                            </div>
                        </div>

                        {/* Ahorra y mejora */}
                        <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay="100">
                            <div className="pricing-card featured">
                                <div className="popular-badge">Plan anual + %</div>
                                <div className="plan-header">
                                    <h3 className="plan-name">Ahorra y mejora</h3>
                                    <p className="plan-subtitle">Activamos tu caso y participamos del ahorro que generamos para ti.</p>
                                </div>
                                <div className="plan-pricing">
                                    <div className="price-wrapper">
                                        <span className="currency">$</span>
                                        <span className="amount monthly-price">10,000</span>
                                    </div>
                                    <p className="billing-info monthly-billing">Pago anual · IVA incluido</p>
                                </div>
                                <div className="plan-features">
                                    <ul className="features-list">
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            <span>Agente de IA 24/7 sin límite de consultas</span>
                                        </li>
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            <span>Gestión y negociación activa con el banco</span>
                                        </li>
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            <span>Reporte detallado por cada consulta</span>
                                        </li>
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            <span>Acompañamiento personalizado de tu asesor</span>
                                        </li>
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            <span>Cobramos éxito solo si el ahorro esta comprobado</span>
                                        </li>
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            <span>Perfilamiento: cada programa al que eres candidato, con su tasa, plazo, línea, garantía y documentos</span>
                                        </li>
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            <span>Revisión de tus condiciones actuales: te decimos qué tasas, comisiones y seguros estás pagando de más</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="plan-action">
                                    <a href="/register" className="btn-plan">Crea tu cuenta</a>
                                </div>
                                <p className="text-light mt-3 mb-0" style={{ fontSize: '0.85rem', lineHeight: '1.5' }}>
                                    Pagas $10,000 MXN (IVA incluido) una vez al año por activar tu cuenta. Después, solo si generamos ahorro o mejora, cobramos un % acordado.
                                </p>
                            </div>
                        </div>

                        {/* Análisis de Buró */}
                        <div className="col-lg-8 offset-lg-2" data-aos="fade-up" data-aos-delay="150">
                            <div className="pricing-card">
                                <div className="plan-header">
                                    <h3 className="plan-name">¿No te están dando crédito? Te decimos por qué.</h3>
                                    <p className="plan-subtitle">
                                        Subes tu Reporte de Crédito Especial y recibes un análisis de qué ve el banco, qué te frena y qué hacer, en orden.
                                    </p>
                                </div>
                                <div className="plan-action">
                                    <a href="https://buy.stripe.com/9B65kEfCz8gZdBI9h24Ja03" className="btn-plan" target="_blank" rel="noopener noreferrer" style={{ background: '#21B4E9', color: '#fff', borderColor: '#21B4E9' }}>
                                        Quiero mi Análisis de Buró
                                    </a>
                                </div>
                                <p className="mt-3 mb-0 text-center" style={{ fontSize: '0.85rem', color: '#555' }}>
                                    Si después activas tu plan anual, te descontamos los $790.
                                </p>
                            </div>
                        </div>

                    </div>

                </div>

            </section>

            {/* Contacto */}
            <section id="contact" className="contact section">
                {/* Section Title */}
                <div className="container section-title" data-aos="fade-up">
                    <h2>Contacto</h2>
                    <p>No vendemos productos bancarios. Solo te decimos qué te conviene.</p>
                </div>

                <div className="container" data-aos="fade-up" data-aos-delay="100">
                    <div className="row g-4">
                        <div className="col-lg-4" data-aos="fade-up" data-aos-delay="150">
                            <div className="quick-contact-wrapper">
                                <div className="contact-card">
                                    <div className="icon-wrapper">
                                    <i className="bi bi-envelope-paper"></i>
                                    </div>
                                    <h4>Soporte vía email</h4>
                                    <p className="contact-detail">contacto@goodlic.com</p>
                                    <span className="availability">Usualmente responde en 2 horas</span>
                                </div>

                                <div className="contact-card">
                                    <div className="icon-wrapper">
                                    <i className="bi bi-whatsapp"></i>
                                    </div>
                                    <h4>Soporte vía WhatsApp</h4>
                                    <a href="https://wa.me/524422971928" target="_blank" rel="noreferrer" className="contact-detail">442 297 1928</a>
                                    <span className="availability">Lun – Sáb 9:00 – 18:00 · Domingo cerrado</span>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-8" data-aos="fade-up" data-aos-delay="200">
                            <div className="main-form-container">
                                <div className="form-intro">
                                    <h2>Envíanos un mensaje</h2>
                                </div>

                                <form action="forms/contact.php" method="post" className="php-email-form modern-form">
                                    <div className="row g-3">
                                        <div className="col-md-12">
                                            <input type="text" className="form-control" name="name" placeholder="Nombre" required="" />
                                        </div>
                                    </div>

                                    <div className="row g-3 mt-1">
                                        <div className="col-md-6">
                                            <input type="email" className="form-control" name="email" placeholder="Correo" required="" />
                                        </div>
                                        <div className="col-md-6">
                                            <input type="text" className="form-control" name="phone" placeholder="Célular (opcional)" />
                                        </div>
                                    </div>

                                    <div className="mt-3">
                                        <textarea className="form-control" name="message" placeholder="Platícanos tus dudas o necesidades" rows="6" required=""></textarea>
                                    </div>

                                    <div className="my-3">
                                        <div className="loading">Cargando</div>
                                        <div className="error-message"></div>
                                        <div className="sent-message">¡Tu mensaje fue enviado. Gracias!</div>
                                    </div>

                                    <button type="submit" className="btn-submit">
                                        <span>Enviar mensaje</span>
                                        <i className="bi bi-arrow-right"></i>
                                    </button>

                                    <div className="form-footer-note">
                                        <i className="bi bi-info-circle"></i>
                                        <span>Usualmente respondemos en un máximo de 24 horas</span>
                                    </div>
                                </form>

                                <div className="social-proof">

                                    <div className="social-channels">
                                        <p>O contáctanos por nuestras redes sociales</p>
                                        <div className="channel-links">
                                            <a href="https://wa.me/524422971928" target="_blank" rel="noreferrer" className="channel-link">
                                                <i className="bi bi-whatsapp"></i>
                                            </a>
                                            <a href="https://www.facebook.com/profile.php?id=61550659125692" target="_blank" rel="noreferrer" className="channel-link">
                                                <i className="bi bi-facebook"></i>
                                            </a>
                                            <a href="https://www.instagram.com/goodlic.mx" target="_blank" rel="noreferrer" className="channel-link">
                                                <i className="bi bi-instagram"></i>
                                            </a>
                                            <a href="#" className="channel-link">
                                                <i className="bi bi-linkedin"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </main>
    )
}

export default Inicio;